export interface Partner {
  name: string;
  logo: string;
  /** Dimensoes intrinsecas do SVG (viewBox). Passadas ao <img> para reservar o
   * aspect-ratio e evitar reflow/CLS na marquee enquanto o logo carrega. */
  width: number;
  height: number;
}

export const PARTNERS: Partner[] = [
  { name: "L'Oréal", logo: "/logos/loreal.svg", width: 159, height: 41 },
  { name: "Stellantis", logo: "/logos/stellantis.svg", width: 220, height: 59 },
  { name: "Nestlé", logo: "/logos/nestle.svg", width: 160, height: 53 },
  { name: "B3", logo: "/logos/b3.svg", width: 66, height: 59 },
  { name: "Jaguar", logo: "/logos/jaguar.svg", width: 102, height: 54 },
  { name: "Land Rover", logo: "/logos/land-rover.svg", width: 102, height: 61 },
  { name: "Saint-Gobain", logo: "/logos/saint-gobain.svg", width: 138, height: 67 },
  { name: "PRIO", logo: "/logos/prio.svg", width: 161, height: 43 },
  { name: "Prudential", logo: "/logos/prudential.svg", width: 195, height: 53 },
  { name: "Volkswagen", logo: "/logos/volkswagen.svg", width: 61, height: 61 },
  { name: "Johnson & Johnson", logo: "/logos/johnson-e-johnson.svg", width: 128, height: 57 },
  { name: "Embraer", logo: "/logos/embraer.svg", width: 208, height: 48 },
  { name: "Dasa", logo: "/logos/dasa.svg", width: 118, height: 43 },
  { name: "Arco", logo: "/logos/arco.svg", width: 89, height: 54 },
  { name: "Nexa", logo: "/logos/nexa.svg", width: 105, height: 38 },
  { name: "Colgate", logo: "/logos/colgate.svg", width: 123, height: 58 },
  { name: "Corteva", logo: "/logos/corteva.svg", width: 168, height: 34 },
  { name: "ISA Energia", logo: "/logos/isa-energia.svg", width: 98, height: 53 },
  { name: "Petrobras", logo: "/logos/petrobras.svg", width: 108, height: 70 },
  { name: "Porto do Açu", logo: "/logos/porto-do-acu.svg", width: 85, height: 60 },
  { name: "Prumo", logo: "/logos/prumo.svg", width: 114, height: 65 },
  { name: "São Martinho", logo: "/logos/sao-martinho.svg", width: 222, height: 53 },
  { name: "Wilson Sons", logo: "/logos/wilson-sons.svg", width: 77, height: 60 },
];
